module.exports = __webpack_public_path__ + "img/qihang_anquan.d21b353d.png";